// Generated by Melange

import * as Atdgen_codec_decode from "melange-atdgen-codec-runtime/atdgen_codec_decode.js";
import * as Atdgen_codec_encode from "melange-atdgen-codec-runtime/atdgen_codec_encode.js";
import * as Buhta_models__Atd from "../Atd.js";
import * as Buhta_models__Protocol_v1_bs from "./Protocol_v1_bs.js";

const write_traits = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "email", t.email),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "phone", t.phone),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "user_id", t.user_id),
                      tl: {
                        hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "display_name", t.display_name),
                        tl: /* [] */0
                      }
                    }
                  }
                });
    });

const read_traits = Atdgen_codec_decode.make(function (json) {
      return {
              email: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("email", Atdgen_codec_decode.string, param);
                    }), json),
              phone: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("phone", Atdgen_codec_decode.string, param);
                    }), json),
              user_id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("user_id", Atdgen_codec_decode.string, param);
                    }), json),
              display_name: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("display_name", Atdgen_codec_decode.string, param);
                    }), json)
            };
    });

const write_string_num = Buhta_models__Atd.StringNum.write_t;

const read_string_num = Buhta_models__Atd.StringNum.read_t;

const write_session_identity = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write_traits, "traits", t.traits),
                    tl: /* [] */0
                  }
                });
    });

const read_session_identity = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
                    }), json),
              traits: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("traits", read_traits, param);
                    }), json)
            };
    });

const write_session = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.bool, "active", t.active),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write_session_identity, "identity", t.identity),
                      tl: /* [] */0
                    }
                  }
                });
    });

const read_session = Atdgen_codec_decode.make(function (json) {
      return {
              active: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("active", Atdgen_codec_decode.bool, param);
                    }), json),
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
                    }), json),
              identity: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("identity", read_session_identity, param);
                    }), json)
            };
    });

const write_login_session = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, write_session, "session", t.session),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "session_token", t.session_token),
                    tl: /* [] */0
                  }
                });
    });

const read_login_session = Atdgen_codec_decode.make(function (json) {
      return {
              session: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("session", read_session, param);
                    }), json),
              session_token: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("session_token", Atdgen_codec_decode.string, param);
                    }), json)
            };
    });

const write_kratos_ui_node_attributes = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "name", t.name),
                  tl: {
                    hd: Atdgen_codec_encode.field_o(undefined, write_string_num, "value", t.value),
                    tl: /* [] */0
                  }
                });
    });

const read_kratos_ui_node_attributes = Atdgen_codec_decode.make(function (json) {
      return {
              name: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("name", Atdgen_codec_decode.string, param);
                    }), json),
              value: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.fieldOptional("value", read_string_num, param);
                    }), json)
            };
    });

const write_kratos_ui_message = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "text", t.text),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "type", t.type_),
                    tl: /* [] */0
                  }
                });
    });

const read_kratos_ui_message = Atdgen_codec_decode.make(function (json) {
      return {
              text: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("text", Atdgen_codec_decode.string, param);
                    }), json),
              type_: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("type", Atdgen_codec_decode.string, param);
                    }), json)
            };
    });

function write__kratos_ui_message_list(param) {
  return Atdgen_codec_encode.list(write_kratos_ui_message, param);
}

function read__kratos_ui_message_list(param) {
  return Atdgen_codec_decode.list(read_kratos_ui_message, param);
}

const write_kratos_ui_node = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, write_kratos_ui_node_attributes, "attributes", t.attributes),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write__kratos_ui_message_list, "messages", t.messages),
                    tl: /* [] */0
                  }
                });
    });

const read_kratos_ui_node = Atdgen_codec_decode.make(function (json) {
      return {
              attributes: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("attributes", read_kratos_ui_node_attributes, param);
                    }), json),
              messages: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("messages", /* [] */0, read__kratos_ui_message_list), json)
            };
    });

function write__kratos_ui_node_list(param) {
  return Atdgen_codec_encode.list(write_kratos_ui_node, param);
}

function read__kratos_ui_node_list(param) {
  return Atdgen_codec_decode.list(read_kratos_ui_node, param);
}

const write_kratos_ui = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "action", t.action),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write__kratos_ui_node_list, "nodes", t.nodes),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, write__kratos_ui_message_list, "messages", t.messages),
                      tl: /* [] */0
                    }
                  }
                });
    });

const read_kratos_ui = Atdgen_codec_decode.make(function (json) {
      return {
              action: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("action", Atdgen_codec_decode.string, param);
                    }), json),
              nodes: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("nodes", read__kratos_ui_node_list, param);
                    }), json),
              messages: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("messages", /* [] */0, read__kratos_ui_message_list), json)
            };
    });

const write_kratos_flow = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "id", t.id),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, write_kratos_ui, "ui", t.ui),
                    tl: /* [] */0
                  }
                });
    });

const read_kratos_flow = Atdgen_codec_decode.make(function (json) {
      return {
              id: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("id", Atdgen_codec_decode.string, param);
                    }), json),
              ui: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("ui", read_kratos_ui, param);
                    }), json)
            };
    });

const write_kratos_error_object = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "message", t.message),
                  tl: {
                    hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "reason", t.reason),
                    tl: {
                      hd: Atdgen_codec_encode.field(undefined, Atdgen_codec_encode.string, "debug", t.debug),
                      tl: /* [] */0
                    }
                  }
                });
    });

const read_kratos_error_object = Atdgen_codec_decode.make(function (json) {
      return {
              message: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("message", "", Atdgen_codec_decode.string), json),
              reason: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("reason", "", Atdgen_codec_decode.string), json),
              debug: Atdgen_codec_decode.decode(Atdgen_codec_decode.fieldDefault("debug", "", Atdgen_codec_decode.string), json)
            };
    });

const write_kratos_error = Atdgen_codec_encode.make(function (t) {
      return Atdgen_codec_encode.obj({
                  hd: Atdgen_codec_encode.field(undefined, write_kratos_error_object, "error", t.error),
                  tl: /* [] */0
                });
    });

const read_kratos_error = Atdgen_codec_decode.make(function (json) {
      return {
              error: Atdgen_codec_decode.decode((function (param) {
                      return Atdgen_codec_decode.field("error", read_kratos_error_object, param);
                    }), json)
            };
    });

const read_decimal = Buhta_models__Protocol_v1_bs.read_decimal;

const write_decimal = Buhta_models__Protocol_v1_bs.write_decimal;

const read_datetime = Buhta_models__Protocol_v1_bs.read_datetime;

const write_datetime = Buhta_models__Protocol_v1_bs.write_datetime;

export {
  read_traits ,
  write_traits ,
  read_string_num ,
  write_string_num ,
  read_session_identity ,
  write_session_identity ,
  read_session ,
  write_session ,
  read_login_session ,
  write_login_session ,
  read_kratos_ui_node_attributes ,
  write_kratos_ui_node_attributes ,
  read_kratos_ui_message ,
  write_kratos_ui_message ,
  read_kratos_ui_node ,
  write_kratos_ui_node ,
  read_kratos_ui ,
  write_kratos_ui ,
  read_kratos_flow ,
  write_kratos_flow ,
  read_kratos_error_object ,
  write_kratos_error_object ,
  read_kratos_error ,
  write_kratos_error ,
  read_decimal ,
  write_decimal ,
  read_datetime ,
  write_datetime ,
}
/* write_traits Not a pure module */
